// src/hooks/useDowntimeStatus.ts
import config from "config";
import { useEffect, useState } from "react";

export default function useDowntimeStatus() {
  const [isDowntime, setIsDowntime] = useState(false);
  useEffect(() => {
    const checkDowntime = async () => {
      try {
        const response = await fetch(config.DOWNTIME_CHECK_URL);
        const data = await response.json();
        const isProd = config.ENVIRONMENT === "production";
        const downtimeStatus = isProd ? data.prod_downtime : data.stage_downtime;

        setIsDowntime(downtimeStatus);
      } catch {
        setIsDowntime(false);
      }
    };

    checkDowntime();
  }, []);

  return isDowntime;
}
